export default __webpack_public_path__ + "3b832c2a31a0d64360824c6b0a006d78.svg";